// The workspace create action now lives in the panel-based form reached via
// the WorkspacesFilters AddButton, so this toolbar renders nothing.
export const WorkspacesToolbar = () => {
  return null;
};
